import api from '../api';

// Sandbox (sample "Brightcart" cluster) lifecycle endpoints.
// Status shape: { exists, deleted, cluster_unique_id }
export const getSandboxStatus = () => api.get('/api/sandbox/status/');
export const restoreSandbox = () => api.post('/api/sandbox/restore/');
export const removeSandbox = () => api.post('/api/sandbox/remove/');
